// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")
require("jquery")


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import "bootstrap";
// import "./bootstrap-datepicker.min";
require('bootstrap-datepicker')
// import('bootstrap-datepicker/locales/*')

// import "bootstrap-datepicker/locales/bootstrap-datepicker.it.js"

import "bootstrap-select"
// https://bootstrap-autocomplete.readthedocs.io/
import "./bootstrap-autocomplete"

// https://cdnjs.com/libraries/bootstrap-datepicker
import "bootstrap-table"

document.addEventListener("turbolinks:load", () => {
    $('[data-toggle="tooltip"]').tooltip()
    $('[data-toggle="popover"]').popover()
})

import "./sb-admin-2.js";
import Cookies from './js.cookie';
window.Cookies = require('./js.cookie')

// import "fabric"
require('fabric')

import "./tableExport.min"
import "./bootstrap-table-export.min"
import "./bootstrap-table-group-by.min"
import "./bootstrap-table-filter-control.min"

// Controllo password https://github.com/adri-sorribas/passtrength
import "./jquery.passtrength"

$(window).on('focus', function () {
    // Controllo quanto la pagina è VECCHIA e la ri carico
    let dactual = new Date();
    let dpage = $('body').attr('nav-holder');
    if (typeof(dpage) != 'undefined') {
        let diff = (((dactual.getTime() / 1000).toFixed()) - dpage);
        // console.log('Holder page: ' + diff);
        // Se la pagina è più vecchia di 5 minuti aggiorno
        if (diff > (60 * 5)) {
            window.location.reload();
        }
    }
});
